import styled from '@emotion/styled'
import * as React from 'react'

import { Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'

const Container = styled.div`
  max-width: 340px;
  min-width: 300px;
`

const PRE = `${i18nKeyPrefix}-CTA-SCHEDULE-NOT-TOURING`

export default function NotTouringTooltip() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <Text>{t(`${PRE}-TEXT`)}</Text>
    </Container>
  )
}
